import { setElementInnerHTML, setElementOnClick } from '../../ui_utils/DomUtils.ts';
import { UIComponentItemScrollCell } from './UIComponentItemScrollCell.ts';
export class UIComponentItemScroll {
    update(itemData) {
        this.clear();
        this.generateItems(itemData);
        this.updateArrowVisibility();
        if (this.scrollable) this.scrollToSelectedItem();
    }
    updateInteractabilityOfElements(isGuest) {
        this.items.forEach((item)=>{
            item.updateInteractability(isGuest);
        });
    }
    resetScroll() {
        if (this.scrollable) this.scrollWrapper.scrollLeft = 0;
        this.updateArrowVisibility();
    }
    initScrolling() {
        if (this.scrollable) {
            setElementOnClick(this.leftArrow, ()=>this.scroll(-this.scrollAmount));
            setElementOnClick(this.rightArrow, ()=>this.scroll(this.scrollAmount));
            this.scrollWrapper.onscroll = ()=>this.updateArrowVisibility();
            return;
        }
        this.leftArrow.style.display = 'none';
        this.rightArrow.style.display = 'none';
        this.scrollWrapper.classList.add('no-scroll');
    }
    initResizeObserver() {
        if (!this.scrollable) return;
        this.resizeObserver = new ResizeObserver(()=>{
            this.updateArrowVisibility();
            this.scrollToSelectedItem();
        });
        this.resizeObserver.observe(this.scrollWrapper);
    }
    scroll(amount) {
        if (!this.scrollable) return;
        const currentScroll = this.scrollWrapper.scrollLeft;
        const maxScroll = this.getMaxScrollPosition();
        const newScroll = Math.max(0, Math.min(maxScroll, currentScroll + amount));
        this.scrollWrapper.scrollTo({
            left: newScroll,
            behavior: 'smooth'
        });
    }
    getMaxScrollPosition() {
        return Math.max(0, this.scrollWrapper.scrollWidth - this.scrollWrapper.clientWidth);
    }
    updateArrowVisibility() {
        if (!this.scrollable) {
            this.leftArrow.style.display = 'none';
            this.rightArrow.style.display = 'none';
            return;
        }
        const { scrollLeft, scrollWidth, clientWidth } = this.scrollWrapper;
        const tolerance = 1;
        const canScrollLeft = scrollLeft > tolerance;
        const canScrollRight = scrollLeft < scrollWidth - clientWidth - tolerance;
        this.leftArrow.style.display = canScrollLeft ? 'block' : 'none';
        this.rightArrow.style.display = canScrollRight ? 'block' : 'none';
    }
    generateItems(itemData) {
        const sortedData = [
            ...itemData
        ];
        sortedData.sort((a, b)=>{
            if (a.available === b.available) return 0;
            return a.available ? -1 : 1;
        });
        const priorityItem = sortedData.find((item)=>item.bannerText !== undefined);
        if (priorityItem) {
            const priorityItemIndex = sortedData.indexOf(priorityItem);
            sortedData.splice(priorityItemIndex, 1);
            sortedData.splice(1, 0, priorityItem);
        }
        sortedData.forEach((item)=>{
            const itemCell = new UIComponentItemScrollCell(this.scrollContainer, item);
            this.items.push(itemCell);
        });
        if (this.scrollable) this.scrollToSelectedItem();
    }
    scrollToSelectedItem() {
        if (!this.scrollable) return;
        requestAnimationFrame(()=>{
            const selectedItem = this.items.find((item)=>item.container.classList.contains('selected'));
            if (!selectedItem) return;
            const itemElement = selectedItem.container;
            const itemWidth = itemElement.offsetWidth;
            const containerWidth = this.scrollWrapper.clientWidth;
            const currentScroll = this.scrollWrapper.scrollLeft;
            const itemStart = itemElement.offsetLeft;
            const itemEnd = itemStart + itemWidth;
            const viewStart = currentScroll;
            const viewEnd = currentScroll + containerWidth;
            const isFullyVisible = itemStart >= viewStart && itemEnd <= viewEnd;
            if (isFullyVisible) return;
            const scrollPosition = itemStart - containerWidth / 2 + itemWidth / 2;
            this.scrollWrapper.scrollTo({
                left: Math.max(0, Math.min(scrollPosition, this.getMaxScrollPosition())),
                behavior: 'smooth'
            });
        });
    }
    clear() {
        setElementInnerHTML(this.scrollContainer, {
            key: 'strings:colonistCommon.utils.emptyString'
        });
        this.items.length = 0;
    }
    constructor(container, itemData, scrollable = true){
        this.items = [];
        this.scrollAmount = 500;
        this.scrollWrapper = container.querySelector('.item-scroll-wrapper');
        this.scrollContainer = this.scrollWrapper.querySelector('.item-scroll-container');
        this.leftArrow = container.querySelector('.scroll-arrow.left-arrow');
        this.rightArrow = container.querySelector('.scroll-arrow.right-arrow');
        this.scrollable = scrollable;
        this.initScrolling();
        this.generateItems(itemData);
        this.updateArrowVisibility();
        this.initResizeObserver();
    }
}
